"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Feature = _interopRequireDefault(require("./Feature"));
var _utils = require("../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class FeatureCollection {
  get features() {
    return this._features;
  }
  constructor(data) {
    data = data || {};
    data.features = data.features || data;
    if (!(0, _utils.isEmpty)(data.features)) {
      this._features = data.features.map(featureData => new _Feature.default(featureData));
    }
  }
}
var _default = exports.default = FeatureCollection;
module.exports = exports.default;